import React, { Component } from 'react';
import { Modal, Tabs, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

const { TabPane } = Tabs;

class LogList extends Component {
    state = {
        data: []
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.loadData();
        }
    }

    loadData = () => {
        // const { type, ownerId, languageType } = this.props;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.personal.queryVitaeLog, {
        //     languageType,
        //     ownerId,
        //     type
        // }).then((res) => {
        //     const { data } = res;
        //     this.setState({ data });
        // }).catch(err => {
        //     console.error(err);
        // });
        this.setState({
            data: [
                {logId: 1, date: '2021-02-26 11:53', version: 'V1', detailList: [{name: '字段', oldValue: '修改前', newValue: '修改后'}]},
                {logId: 2, date: '2021-02-26 11:53', version: 'V2', detailList: [{name: '字段', oldValue: '修改前', newValue: '修改后'}]}
            ]
        });
    }

    getColumns = () => {
        const columns = [{
            title: '字段名称',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        }, {
            title: '更新前',
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: 370,
        }, {
            title: '更新后',
            dataIndex: 'newValue',
            key: 'newValue',
        }];
        return columns;
    }

    render() {
        const { data } = this.state;
        return (
            <div style={{ height: 320, overflowY: 'auto' }}>
                {
                    (data || []).length > 0 ?
                        data.map(item => {
                            const { logId, date, version, detailList } = item;
                            return (
                                <div key={logId} style={{marginBottom: 20}}>
                                    <div style={{ margin: 10, fontWeight: 'bold' }}>
                                        修改时间：{date}
                                        <span className="ant-divider" />
                                        修改版本：{version}
                                    </div>
                                    <TableC
                                        data={detailList}
                                        columns={this.getColumns()}
                                        className="logTable"
                                    />
                                </div>
                            );
                        })
                    :
                        <div style={{ lineHeight: '320px', textAlign: 'center' }}>暂无更新</div>
                }
            </div>
        );
    }
}

class ModifyLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            activeKey: 'modifyQuotation',
            panes: [{
                title: '修改报价单',
                key: 'modifyQuotation',
                content: this.getContent,
            }, {
                title: '封面',
                key: 'cover',
                content: this.getContent,
            }, {
                title: '公司简介',
                key: 'background',
                content: this.getContent,
            }, {
                title: '报价参数',
                key: 'params',
                content: this.getContent,
            }, {
                title: '总价',
                key: 'total',
                content: this.getContent,
            }, {
                title: '报价明细',
                key: 'detail',
                content: this.getContent,
            }, {
                title: '服务内容',
                key: 'serContent',
                content: this.getContent,
            }, {
                title: '付款计划',
                key: 'payment',
                content: this.getContent,
            }],
        };
    }

    show = () => {
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (key) => {
        const { activeKey } = this.state;
        if (activeKey == key) {
            return <LogList type={activeKey} />;
        } else {
            return null;
        }
    }

    render() {
        const { panes, activeKey, visible } = this.state;
        return (
            <Modal
                title="修改日志"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="1000px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                </Tabs>
            </Modal>
        );
    }
}

export default ModifyLog;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/Components/ModifyLog.js